<template>
<div class="load-more is-size-7">
    <button
        @click="loadMore"
        v-if="showButton || isLoading"
        :class="{
            'is-loading': isLoading,
            'is-danger': hasError
        }"
        class="button is-small">
        {{ hasError ? 'Error. Click to retry.' : $t('showMore') }}
    </button>
    <!-- Don't show "allPostsLoaded" if user hasn't paginated  -->
    <div v-else-if="hasPaginatedCurrentList">
        {{ $t('allPostsLoaded') }}
    </div>
</div>
</template>

<script>
export default {
    name: 'LoadMore',
    props: {
        isLoading: Boolean,
        hasSuggestions: Boolean,
        hasMorePages: Boolean,
        hasError: Boolean,
        lastScrollToBottomDate: Date,
    },
    data: () => ({
        hasPaginatedCurrentList: false,
    }),
    computed: {
        showButton: vm => vm.hasSuggestions && vm.hasMorePages
    },
    watch: {
        lastScrollToBottomDate: 'loadMore'
    },
    methods: {
        loadMore () {
            this.hasPaginatedCurrentList = true
            this.$emit('loadMore')
        }
    }
}
</script>

<style lang="scss" scoped>
.load-more {
    @include flex-center-children;
    padding: 10px;
}
</style>
